import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TextField, Typography } from '@mui/material';
import { Button, PasswordValidationWidget } from '../../../components';

import { AquaLogo } from '@wave-engagement/wave-react';
import { forgotPasswordConfirm } from '../../../api';
import { useAlerts } from '../../../alerts';

const ForgotPassword = () => {
  const { token } = useParams();
  const { setSuccess, setError, clearErrors } = useAlerts();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    return () => clearErrors();
  }, []);

  const onConfirmChange = (e) => {
    e.preventDefault();

    if (token == null || token === '') {
      setError('Invalid token. Please check your email.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setIsLoading(true);

    forgotPasswordConfirm({ password, verificationCode: token }).then(() => {
      setIsLoading(false);
      setSuccess('Your password has been reset. You can now login with your new password.');

      // Redirect to login
      navigate('/auth/login');
    }).catch((error) => {
      setIsLoading(false);
      setError(error ?? 'An error occurred while trying to reset your password.');
    });
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '3em' }}>
        <img src={AquaLogo} alt='Wave Engagement Logo' style={{ width: '100%', maxWidth: '300px', objectFit: 'contain', marginTop: '3em' }} />
      </div>
      <Typography variant='h1' gutterBottom>Forgot Password</Typography>

      <form onSubmit={onConfirmChange}>
        {/* Password */}
        <TextField
          required
          label='Password'
          type='password'
          onChange={(e) => setPassword(e.target.value)}
          disabled={isLoading}
          variant='filled'
          style={{
            width: '100%',
            marginBottom: '0.5em'
          }}>
        </TextField>

        <PasswordValidationWidget password={password} />

        {/* Confirm Password */}
        <TextField
          required
          label='Confirm Password'
          type='password'
          onChange={(e) => setConfirmPassword(e.target.value)}
          disabled={isLoading}
          variant='filled'
          style={{
            width: '100%',
            marginBottom: '0.5em'
          }}>
        </TextField>

        {/* Submit */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            type='submit'
            style={{ width: '48%', marginTop: '1em' }}
            isLoading={isLoading}>
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}
export default ForgotPassword;